(() => {
  const mobile = matchMedia('(max-width: 740px)');
  const original = new WeakMap();
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('joy-loyalty-widget').forEach(widget => {
      if (!widget.hasAttribute('fab-design')) return;
      if (!original.has(widget)) original.set(widget, {
        design: widget.getAttribute('fab-design'),
        position: widget.getAttribute('position')
      });
      const saved = original.get(widget);
      const values = {
        'fab-design': mobile.matches ? 'icon_only' : saved.design,
        position: mobile.matches ? 'right' : saved.position
      };
      Object.entries(values).forEach(([name, value]) => {
        if (widget.getAttribute(name) === value) return;
        if (value === null) widget.removeAttribute(name);
        else widget.setAttribute(name, value);
      });
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['fab-design', 'position']
  });
  mobile.addEventListener('change', schedule);
  update();
})();